import React from 'react'
import { i18nText } from '../../../Services';

export const StaticText = props => {
    const { context, defaultValue, element, modelPath } = props;
    const inputModel = context.readModel(modelPath, defaultValue);

    if (i18nText.exists(element.text))
        return (
            <span className={element.className}>{i18nText.getText(element.text)}</span>
        );

    return (
        <span className={element.className}>{inputModel?.value}</span>
    )
}

export default StaticText;
